import { PropsWithChildren } from 'react';
import { useCreateModalStore } from './useCreateModalStore';

export const ModalProvider = ({ children }: PropsWithChildren) => {
  const modalSlots = useCreateModalStore((state) => state.modalSlots);

  return (
    <>
      {children}
      {modalSlots.map(({ Component, name, props }) => (
        <Component key={name} {...props} />
      ))}
    </>
  );
};
